import { create } from "zustand";

export const useCustomizationStore = create((set) => ({
  activeReorderTab: null,
  setActiveReorderTab: (tabName) => set({ activeReorderTab: tabName }),

  sectionConfig: {},
  setSectionConfig: (value) =>
    set((prev) => ({
      ...prev,
      sectionConfig: { ...prev.sectionConfig, ...value },
    })),

  sectionConfigLoading: true,
  setSectionConfigLoading: (value) => set({ sectionConfigLoading: value }),
}));
